import { reducers } from '@wix/da-shared-react/pkg/redux/shared';

const rootReducers = {
  ...reducers,
};

export default rootReducers;
